import LayoutPedidoPage from './LayoutPedido'

export default function LayoutRomaneioPage() {
  return <LayoutPedidoPage tipoDoc="romaneio" />
}
